<template>
  <div class="login-page page">
    <div class="page-mask"></div>
    <div class="page-content">
      <div class="top-bar">
        <van-icon name="arrow-left" class="back-icon" @click="back" />
        <div class="language-entry" @click="toLanguage">
          <img :src="languageIcon" alt="language" />
        </div>
      </div>

      <div class="wrapper">
        <div class="logo-wrap">
          <img class="logo-image" src="/img/login/eharmony-logo.png" alt="logo" />
        </div>

        <div class="login-form">
          <van-field
            v-model.trim="username"
            clearable
            input-align="center"
            class="input"
            :placeholder="$t('auth.username_place')"
          />

          <van-field
            v-model="password"
            :type="passwordType"
            input-align="center"
            class="input"
            :placeholder="$t('auth.pwd_place')"
          >
            <template slot="right-icon">
              <van-icon
                :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                class="password-icon"
                @click="switchPasswordType"
              />
            </template>
          </van-field>

          <div class="register-text" @click="toRegister">
            {{ $t("auth.no_account") }}
          </div>

          <van-button class="login-btn" type="primary" @click="doLogin">
            {{ $t("auth.login") }}
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import zhIcon from "../images/language/zh_cn.png";
import enIcon from "../images/language/en_us.png";
import jaIcon from "../images/language/ja_jp.svg";

export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      lang: "ja",
      password: this.inputValue,
      passwordType: "password",
    };
  },
  computed: {
    languageIcon() {
      const iconMap = {
        zh: zhIcon,
        en: enIcon,
        ja: jaIcon,
      };

      return iconMap[this.lang] || jaIcon;
    },
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || this.$t("auth.lang") || "ja";
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toLanguage() {
      this.$router.push({ path: "/Language" });
    },
    toRegister() {
      this.$router.push({ path: "/Register" });
    },
    doLogin() {
      if (!this.username) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }

      if (!this.password) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }

      this.$http({
        url: "member_login",
        method: "get",
        data: {
          username: this.username,
          password: this.password,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push({ path: "/Mine" });
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.login-page {
  position: relative;
  min-height: 100%;
  overflow: hidden;
  background: linear-gradient(180deg, #ecb3c1 0%, #d5bee4 42%, #5d62dc 100%);
}

.page-mask {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(236, 179, 193, 0.88) 0%, rgba(213, 190, 228, 0.5) 42%, rgba(123, 118, 221, 0.36) 68%, rgba(93, 98, 220, 0.2) 100%),
    url("/img/login/logo_bg.jpg") no-repeat center bottom / cover;
  opacity: 0.9;
}

.page-mask::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 46%;
  background: linear-gradient(180deg, rgba(96, 103, 229, 0) 0%, rgba(97, 104, 229, 0.45) 28%, rgba(94, 101, 224, 0.85) 100%);
}

.page-content {
  position: relative;
  z-index: 1;
  min-height: 100%;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 22px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.45);
}

.back-icon {
  color: #6f5f7d;
  font-size: 56px;
}

.language-entry {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 6px 16px rgba(96, 83, 115, 0.12);
}

.language-entry img {
  display: block;
  width: 100%;
  height: 100%;
}

.wrapper {
  padding: 10px 32px 0;
}

.logo-wrap {
  display: flex;
  justify-content: center;
  margin: 18px 0 46px;
}

.logo-image {
  width: 128px;
  height: 128px;
  border-radius: 26px;
  object-fit: cover;
  box-shadow: 0 10px 24px rgba(105, 73, 87, 0.14);
}

.login-form {
  padding-bottom: 120px;
}

.input {
  margin-bottom: 24px;
  min-height: 92px;
  border: none;
  border-radius: 46px;
  overflow: hidden;
}

::v-deep .input.van-cell {
  margin-bottom: 24px;
  padding: 0 28px;
  min-height: 92px;
  border: none;
  border-radius: 46px;
  background: rgba(98, 79, 118, 0.92);
}

::v-deep .input.van-cell::after {
  display: none;
}

.register-text {
  margin: 8px 0 54px;
  text-align: center;
  color: rgba(255, 255, 255, 0.92);
  font-size: 30px;
  line-height: 42px;
}

.login-btn {
  width: 100%;
  height: 92px;
  border: none;
  border-radius: 46px;
  background: linear-gradient(90deg, #5864e8 0%, #5c63e3 100%);
  box-shadow: none;
  font-size: 34px;
  font-weight: 700;
  color: #fff;
}

::v-deep .van-field__body {
  min-height: 92px;
}

::v-deep .van-field__control {
  color: #fff;
  font-size: 28px;
  line-height: 40px;
}

::v-deep .van-field__control::placeholder {
  color: rgba(255, 255, 255, 0.9);
}

::v-deep .van-field__right-icon {
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.9);
}

.password-icon {
  font-size: 42px;
}

::v-deep .van-button__text {
  letter-spacing: 1px;
}
</style>
